import React from "react";
import './c64_blockquote.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import {insertHtml} from "../../utils/dom";

class BlockquoteRecommendation extends TemplateComponent {

    componentRender(data) {

        return (
            <div id="blockquote-recommendation">
                <div className="container-fluid blockquote-container">
                    <div className="row">
                        <div className="col">
                            <div className="vertical-line"></div>
                            <div className={!isMobileOnly ? 'blockquote-text' : 'blockquote-text-mob'} {...insertHtml(data.blockquote_text)} />
                            {data.blockquote_author ? <div className="blockquote-author">{data.blockquote_author}</div> : null}
                            {data.blockquote_subtitle ? <div className="blockquote-subtitle">{data.blockquote_subtitle}</div> : null}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default BlockquoteRecommendation;
